export default {
  addOns: 'Doplňky',
  availabilityDaySelector: 'Výběr data dostupnosti',
  unavailable: 'Nedostupné',
  person: 'osoba',
  people: 'lidé',
  reserveNow: 'Rezervovat nyní',
  selectTime: 'Vybrat čas',
  select: 'Vybrat',
  reserve: 'Rezervovat',
  time: 'Čas',
  tier: 'Úroveň',
  questions: 'Otázky',
  addToCart: 'Přidat do košíku',
  checkout: 'Pokladna',
  total: 'Celkem',
  availability: 'Dostupnost',
  whatsIncluded: 'Co je zahrnuto',
  showMore: 'Zobrazit více',
  showLess: 'Zobrazit méně',
  session: 'Sezení',
  viewDetails: 'Zobrazit podrobnosti',
  findAvailability: 'Najít dostupnost',
  loading: 'Načítání',
  capacity: 'Kapacita',
  noAvailableSessionsOnThisDate: 'Žádná dostupná sezení na tento datum',
  noGroupAvailableOnThisDateAndTime:
    'Žádná {{groupTitle}} dostupná v tento datum a čas',
  noCollectionFound: 'Žádná sbírka nenalezena!',
  noResourceGroupFound: 'Žádná skupina zdrojů nenalezena!',
  noData: 'Žádná data!',
  continue: 'Pokračovat',
  night: 'noc',
  nights: 'nocí',
  noAvailableSessionsForSelectedDates:
    'Některá data ve vašem výběru nemají dostupné relace. Vyberte prosím jiná data.',
  from: 'od',
  dateRangeSelector: 'Výběr rozsahu dat',
  priceTierRadioGroup: 'Výběr úrovně ceny',
  startTime: 'Čas začátku',
  duration: 'Délka',
  lengthOfStay: 'Délka pobytu',
  startDate: 'Datum začátku',
  endDate: 'Datum konce',
  selectDates: 'Vyberte data',
  more: 'Více',
  selectStartTime: 'Vyberte čas začátku',
  endTime: 'Čas konce',
  selectEndTime: 'Vyberte čas konce',
  morning: 'Dopoledne',
  afternoon: 'Odpoledne',
  save: 'Uložit',
  selectDuration: 'Vyberte délku',
  forLength: 'na {{length}}',
  moreDates: 'dalších {{count}}',
  addDate: 'Přidat datum',
  start: 'Začátek',
  end: 'Konec',
  pickupFrom: 'Vyzvednutí od',
  returnBy: 'Vrácení do',
  day: 'den',
  days: 'dny',
  hour: 'hodina',
  hours: 'hodiny',
};
